<template>
  <v-dialog v-model="dialog" scrollable max-width="500">
    <v-card>
      <v-card-title>
        部署情報編集
        <v-spacer />
        <IconButton icon="mdi-close" @click="cancel" />
      </v-card-title>

      <v-card-text>
        <v-form ref="staff_form">
          <v-container>
            <v-row>
              <v-col cols="6">
                <FormInputComponent
                  label="表示順"
                  type="number"
                  v-model="showOrder"
                  rules="required"
                  :counter="4"
                />
              </v-col>
              <v-col cols="12">
                <FormInputComponent
                  label="部署名"
                  v-model="departmentName"
                  rules="required"
                  :counter="20"
                />
              </v-col>
              <v-col cols="12">
                <FormInputComponent
                  label="部署名ふりがな"
                  v-model="departmentNameFurigana"
                  rules="required"
                  :counter="20"
                />
              </v-col>
            </v-row>
            <v-row v-if="loading"
              ><v-col><Loader :loading="loading" /></v-col
            ></v-row>
            <v-row>
              <v-col>
                <Button @click="erntry_confirm" color="primary">登録</Button>
              </v-col>
              <v-col v-if="!entryFlg">
                <Button @click="delete_confirm" color="danger">削除</Button>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <ConfirmDialog
        ref="confirm"
        title="部署情報編集"
        :message="confirmMessage"
        buttonMessage="OK"
        @confirm="editPositionInfo"
      >
      </ConfirmDialog>

      <DialogMessage ref="dialog" />
    </v-card>
  </v-dialog>
</template>
<script>
import axios from 'axios';
import config from '../../../const.js';
import message from '../../../message.js';
import moment from 'moment';
import ConfirmDialog from '@/components/Common/ConfirmMessage.vue';
import { getSessionStorageItem, isNumber } from '@/common.js';

export default {
  components: {
    ConfirmDialog,
  },
  data: () => ({
    loading: false,
    dialog: false,
    confirm: false,
    entryFlg: false,
    editFlg: false,
    deleteFlg: false,
    resolve: null,
    reject: null,

    confirmMessage: null,

    departmentKey: null,
    organaizationKey: null,

    // 表示順序
    showOrder: 0,
    // 部署名
    departmentName: null,
    // 部署名フリガナ姓
    departmentNameFurigana: null,
    departmentNameFuriganaRules: [(v) => !!v || '必須入力項目です'],

    expiration: null,
    createdAt: null,
    updateAt: null,

    options: {
      color: 'primary',
      width: 300,
    },
  }),
  created() {},
  methods: {
    open(item, options) {
      this.dialog = true;
      this.confirm = false;
      this.input_image = null;
      this.uploadImageUrl = '';

      if (item == null) {
        this.entryFlg = true;
        this.editFlg = false;
        (this.departmentKey = null),
          (this.organaizationKey = null),
          (this.showOrder = null),
          (this.departmentName = null),
          (this.departmentNameFurigana = null),
          (this.expiration = null),
          (this.createdAt = null),
          (this.updateAt = null);
      } else {
        this.entryFlg = false;
        this.editFlg = true;

        this.departmentKey = item.DEPARTMENT_KEY;
        this.organaizationKey = item.ORGANIZATION_KEY;
        (this.showOrder = item.SHOW_ORDER),
          (this.departmentName = item.DEPARTMENT_NAME),
          (this.departmentNameFurigana = item.DEPARTMENT_NAME_FURIGANA),
          (this.expiration = item.EXPIRATION),
          (this.createdAt = item.CREATED_AT);
        this.updateAt = item.UPDATED_AT;
      }
      this.options = Object.assign(this.options, options);

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    erntry_confirm() {
      // 入力チェック
      if (!this.$refs.staff_form.validate()) {
        return;
      }
      // 表示順数値チェック
      if (!isNumber(this.showOrder)) {
        let warnStr = message.MSG_WARN_SHOWO_ORDER_ERROR;
        let warnStrReplace = warnStr.replace(/a/g, '表示順');
        this.$refs.dialog.open('warning', warnStrReplace);
        return;
      }
      // 部署名称存在チェック
      this.checkDepartmentExists();
    },
    async delete_confirm() {
      // 入力チェック
      if (!this.$refs.staff_form.validate()) {
        // チェックエラー
        return;
      }

      // ローディング画像表示
      this.loading = true;

      let userInfo = getSessionStorageItem();
      await axios
        .get(
          config.CONNECT_URL +
            '/Encouragements/manage/members/' +
            userInfo.SESSION_ID +
            '/' +
            userInfo.USER_ID +
            '/' +
            userInfo.ORGANIZATION_KEY +
            '/' +
            config.EMPTY_STRING +
            '/' +
            config.EMPTY_STRING
        )
        .then((response) => {
          // 部署データ取得
          this.loading = false;

          let hasDepartment = false;
          for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].DEPARTMENT_NAME == this.departmentName) {
              hasDepartment = true;
              break;
            }
          }
          if (hasDepartment) {
            let msgStr =
              '[' +
              this.departmentName +
              ']の部署情報は、既に使用されているため削除できません。';
            this.$refs.dialog.open('info', msgStr);
            return;
          } else {
            // 確認ダイアログ表示
            this.deleteFlg = true;
            this.confirmMessage =
              '[' + this.departmentName + ']の部署情報を削除しますか？';
            this.$refs.confirm.open();
          }
        })
        .catch((error) => {
          this.loading = false;

          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
          return;
        });
    },
    checkDepartmentExists() {
      // ローディング画像表示
      this.loading = true;

      let userInfo = getSessionStorageItem();
      axios
        .get(
          config.CONNECT_URL +
            '/Encouragements/manage/department/' +
            userInfo.SESSION_ID +
            '/' +
            userInfo.USER_ID +
            '/' +
            userInfo.ORGANIZATION_KEY
        )
        .then((response) => {
          // 部署データ取得
          this.loading = false;

          let useDepartment = false;
          for (let i = 0; i < response.data.length; i++) {
            if (this.departmentName == response.data[i].DEPARTMENT_NAME) {
              useDepartment = true;
              break;
            }
          }
          if (useDepartment) {
            let msgStr =
              '[' +
              this.departmentName +
              ']の部署情報は、既に存在するため登録できません。';
            this.$refs.dialog.open('info', msgStr);
            return;
          } else {
            // 確認ダイアログ表示
            this.deleteFlg = false;
            this.confirmMessage =
              '[' + this.departmentName + ']の部署情報を登録しますか？';
            this.$refs.confirm.open();
          }
        })
        .catch((error) => {
          this.loading = false;

          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
          return;
        });
    },
    editPositionInfo() {
      // セッションチェック
      let userInfo = getSessionStorageItem();
      if (userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        this.loading = false;
        return;
      }
      if (this.deleteFlg) {
        // 削除処理
        this.deleteDepartmentInfoRequest();
      } else {
        // 登録処理
        this.editDepartmentInfoRequest();
      }
    },
    editDepartmentInfoRequest() {
      // ローディング画像表示
      this.loading = true;
      // ユーザ情報の取得
      let userInfo = getSessionStorageItem();

      // ユーザ情報作成
      if (this.entryFlg) {
        // 新規登録
        this.departmentKey =
          userInfo.ORGANIZATION_KEY + moment().format('YYYYMMDDHHmmss');
        this.createdAt = moment().format('YYYYMMDDHHmmss');
      }

      // 共通
      this.expiration = '0'; // 使用開始
      this.updateAt = moment().format('YYYYMMDDHHmmss');

      //----- 部署情報登録リクエストPOST
      axios
        .post(config.CONNECT_URL + '/Encouragements/manage/department/entry', {
          SESSION_ID: userInfo.SESSION_ID,
          SESSION_USER_ID: userInfo.USER_ID,

          DEPARTMENT_KEY: this.departmentKey,
          ORGANIZATION_KEY: userInfo.ORGANIZATION_KEY,
          DEPARTMENT_NAME: this.departmentName,
          DEPARTMENT_NAME_FURIGANA: this.departmentNameFurigana,
          SHOW_ORDER: this.showOrder,
          EXPIRATION: this.expiration,
          CREATED_AT: this.createdAt,
          UPDATED_AT: this.updateAt,
        })
        .then((response) => {
          // ローディング画像終了
          this.loading = false;

          let msgStr = '';
          if (response.status == 200) {
            msgStr = message.MSG_INFO_DEPARTMENT_ENTRY_COMPLETE;
            this.$refs.dialog.open('info', msgStr);
            this.$emit('edit');
          }
        })
        .catch((error) => {
          // ローディング画像終了
          this.loading = false;

          let errStr = '';
          if (error.response.status == 400) {
            errStr = message.MSG_ERROR_SESSION_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          }
        });

      this.resolve(true);
      this.dialog = false;
    },
    deleteDepartmentInfoRequest() {
      // ローディング画像表示
      this.loading = false;
      // ユーザ情報の取得
      let userInfo = getSessionStorageItem();

      // 新規登録モードの場合は処理終了
      if (this.entryFlg) {
        return;
      }

      //----- 部署情報削除リクエストPOST
      axios
        .post(config.CONNECT_URL + '/Encouragements/manage/department/delete', {
          SESSION_ID: userInfo.SESSION_ID,
          SESSION_USER_ID: userInfo.USER_ID,
          DEPARTMENT_KEY: this.departmentKey,
        })
        .then((response) => {
          // ローディング画像終了
          this.loading = false;

          let msgStr = '';
          if (response.status == 200) {
            msgStr =
              this.departmentName + message.MSG_INFO_DEPARTMENT_DELETE_COMPLETE;
            this.$refs.dialog.open('info', msgStr);
            this.$emit('edit');
          }
        })
        .catch((error) => {
          // ローディング画像終了
          this.loading = false;

          let errStr = '';
          if (error.response.status == 400) {
            errStr = message.MSG_ERROR_SESSION_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          }
        });

      this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    },
  },
};
</script>
<style>
.inner {
  padding-top: 10px;
  display: flex;
  justify-content: space-evenly;
}
</style>
